export default __webpack_public_path__ + "static/media/ha.8342dfb3.jpg";